import styled from 'styled-components';

import { HueTextInput } from '../HueTextInput';

const StyledInputContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledHexTextInput = styled(HueTextInput).attrs({
	maxLength: 6,
	spellCheck: false,
} as React.HTMLAttributes<HTMLInputElement>)`
	width: 90px;
	height: 40px;
	padding-left: 25px;
`;

const StyledRgbTextInput = styled(HueTextInput).attrs({
	type: 'number',
	min: 0,
	max: 255,
} as React.HTMLAttributes<HTMLInputElement>)`
	width: 60px;
	height: 40px;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;

const StyledRgbContainer = styled.div`
	display: flex;
	gap: 10px;
	margin: 0 19px 0 30px;
`;

export {
	StyledHexTextInput,
	StyledInputContainer,
	StyledRgbContainer,
	StyledRgbTextInput,
};
